const EWalletConst = {
    PredefinedValues: [
        1,
        2,
        3,
        5,
        10
    ],
    getMaxEWalletAmount(): number {
        return 60;
    }    
}

export default EWalletConst;